import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { TableList } from '@/types/general';

import type { RootState } from '../index';

interface ActiveTableProps {
  table: TableList | null;
  refresh?: boolean;
}

interface TableSliceProps {
  activeTable: ActiveTableProps;
}

const initialState: TableSliceProps = {
  activeTable: { table: null, refresh: false },
};

export const tableSlice = createSlice({
  name: 'table',
  initialState,
  reducers: {
    setActiveTable(state, action: PayloadAction<ActiveTableProps>) {
      state.activeTable = action.payload;
    },
    refreshActiveTable(state) {
      state.activeTable.refresh = !state.activeTable.refresh;
    },
  },
});

export const { setActiveTable, refreshActiveTable } = tableSlice.actions;

export const getActiveTable = (state: RootState): ActiveTableProps => state.table.activeTable;
